var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.625 6.25C4.80937 6.25 4.12313 6.77375 3.865 7.5H0V8.75H3.865C4.12313 9.47625 4.80937 10 5.625 10C6.44063 10 7.12687 9.47625 7.385 8.75H12.5V7.5H7.385C7.12687 6.77375 6.44063 6.25 5.625 6.25ZM9.375 3.125C8.55937 3.125 7.87313 3.64875 7.615 4.375H0V5.625H7.615C7.87313 6.35125 8.55937 6.875 9.375 6.875C10.1906 6.875 10.8769 6.35125 11.135 5.625H12.5V4.375H11.135C10.8769 3.64875 10.1906 3.125 9.375 3.125ZM12.5 1.25V2.5H4.885C4.62687 3.22625 3.94062 3.75 3.125 3.75C2.30938 3.75 1.62312 3.22625 1.365 2.5H0V1.25H1.365C1.62312 0.52375 2.30938 0 3.125 0C3.94062 0 4.62687 0.52375 4.885 1.25H12.5Z",
    fill: "#486581"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.30027630be2b00ed6397b5801ad9adb5.svg";
export { ForwardRef as ReactComponent };